import { connect } from "react-redux";
import { Col, Modal, Row } from "react-bootstrap";
import React, {
  useRef,
  useMemo,
  useState,
  useEffect,
  useCallback,
} from "react";

import AddCustomItem from "./AddCustomItem";
import VendorDropdown from "./VendorDropdown";
import EditOrResetCogs from "./EditOrResetCogs";
import Button from "../../../../shared/components/Buttons/Button";
import SearchInventory from "../../Items/SearchInventory/SearchInventory";
import BatchProductEdit from "../../Items/AddBatchInventory/BatchProductEdit";
import ConfirmationModal from "../../Items/ConfirmationModal/ConfirmationModal";
import BatchBulkUpdateModal from "../../Items/AddBatchInventory/BatchBulkUpdateModal";
import NewDatePicker from "../../../../shared/components/datePickerDropDown/NewDatePicker";
import SimpleInputTextField from "../../../../shared/components/inputTextField/SimpleInputTextField";
import EditableReactDataTableComponent from "../../../../shared/components/table/EditableReactDataTableComponent";
import InventoryOverviewThreeCards from "../../../../shared/components/inventoryOverviewThreeCards/InventoryOverviewThreeCards";
import {
  systemActions,
  invoiceActions,
  inventoryActions,
} from "../../../../redux/actions";
import {
  AddIcon,
  ClockIcon,
  DeleteIcon,
} from "../../../../assets/icons/iconsProvider";
import {
  customToast,
  isSpinnerEnabled,
  handleResetPrices,
  getInStockProducts,
  addToCartInBatchTrade,
  handleBatchBulkDelete,
  handleBulkUpdateCondition,
  handleTotalCogsValueChange,
  setDefaultProductDataObject,
  parseToThousandSeperatorWholeNumber,
  handleCalculateEachProductPercentage,
  parseToThousandSeperatorDecimalNumber,
  isAllSystemHasSerialNumber,
  getBatchTotalCalculation,
} from "../../../../shared/utility";
import {
  toastType,
  EMPTY_STRING,
  toastMessages,
  invoiceConstants,
  inventoryConstants,
  buttonNameConstants,
  buttonTypeConstants,
  transactionConstants,
  BATCH_INVENTORY_DEFAULT_PRODUCT_OBJECT,
  TABLE_IDS,
} from "../../../../constants";
import { getAddInvoiceColumns } from "../../../../shared/utilities/columnHeadersUtility/invoice";

const AddInvoice = ({
  shopify,
  addInvoice,
  productTags,
  editInvoice,
  spinnerArray,
  currentStore,
  updateInvoice,
  tradeDiscount,
  activateSpinner,
  editInvoiceData,
  itemOrganization,
  invoiceGridState,
  deactivateSpinner,
  isAddInvoiceModal,
  setEditInvoiceData,
  handleFulfillInvoice,
  invoiceBatchInventory,
  toggleAddInvoiceModal,
  setInvoiceBatchInventory,
  priceChartingProductInfo,
  emptyPriceChartingProductObject,
}) => {
  //-------Reducer
  const { markupPresets, tradeinMargin } = tradeDiscount;
  const { customTypes, customCategories } = itemOrganization;
  const { shopifySettings } = shopify;

  //-------useref
  const asyncSelectRef = useRef();
  //------useState
  const [totalCost, setTotalCost] = useState(0);
  const [isBulkModal, setIsBulkModal] = useState(false);
  const [rarities, setRarities] = useState(EMPTY_STRING);
  const [editTradeObject, setEditTradeObject] = useState({});
  const [editCustomProduct, setEditCustomProduct] = useState({});
  const [defaultSortFieldId, setDefaultSortFieldId] = useState();
  const [isCustomItemModal, setIsCustomItemModal] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(EMPTY_STRING);
  const [bulkUpdateCondition, setBulkUpdateCondition] = useState("");
  const [selectedRarity, setSelectedRarity] = useState(EMPTY_STRING);
  const [toggledClearRows, setToggleClearRows] = React.useState(false);
  const [isConfirmationModal, setIsConfirmationModal] = useState(false);
  const [rowsToUpdateCondition, setRowsToUpdateCondition] = useState([]);
  const [note, setNote] = useState(editInvoiceData?.note || EMPTY_STRING);
  const [addInventoryItemModal, setAddInventoryItemModal] = useState(false);
  const [invoiceDate, setInvoiceDate] = useState(
    editInvoiceData?.invoiceDate || new Date()
  );
  const [invoiceId, setInvoiceId] = useState(
    editInvoiceData?.invoiceId || EMPTY_STRING
  );
  const [productDataObject, setProductDataObject] = useState(
    BATCH_INVENTORY_DEFAULT_PRODUCT_OBJECT
  );
  const totalValues = useMemo(
    () => getBatchTotalCalculation(invoiceBatchInventory, false),
    [invoiceBatchInventory]
  );
  const [gridState, setGridState] = useState({
    pageSize: 500,
    pageIndex: 0,
    sortBy: [],
  });

  //-------Toggle confirmation modal
  const toggleConfirmationModal = () => {
    setIsConfirmationModal(!isConfirmationModal);
  };

  //------handle hide modal
  const handleHideModal = () => {
    toggleAddInvoiceModal();
    setInvoiceBatchInventory([]);
    setEditInvoiceData(EMPTY_STRING);
  };

  //-------Toggle Add Inventoty Item Modal
  const toggleAddInventoryItemModal = () =>
    setAddInventoryItemModal(!addInventoryItemModal);

  //-------Toggle Custom Item Modal
  const toggleCustomItemModal = () => {
    setIsCustomItemModal(!isCustomItemModal);
  };

  //-------handle edit button click
  const handleEditCardClick = (productDetail) => {
    if (productDetail?.apiSource === inventoryConstants.STORE_CUSTOM_PRODUCT) {
      setEditCustomProduct(productDetail);
      toggleCustomItemModal();
    } else {
      setEditTradeObject(productDetail);
      toggleAddInventoryItemModal();
    }
  };

  //-------column headers
  const columnHeaders = useMemo(
    () =>
      getAddInvoiceColumns({
        productTags,
        currentStore,
        tradeinMargin,
        markupPresets,
        handleEditCardClick,
        invoiceBatchInventory,
        setInvoiceBatchInventory,
      }),
    [invoiceBatchInventory]
  );

  const handleInvoiceSubmit = (type) => {
    if (!invoiceId) {
      customToast(toastMessages.INVOICE_ID_REQUIRED, toastType.ERROR);
      return;
    } else if (!invoiceDate) {
      customToast(toastMessages.INVOICE_DATE_REQUIRED, toastType.ERROR);
      return;
    } else if (!selectedVendor?.value) {
      customToast(toastMessages.VENDOR_IS_REQUIRED, toastType.ERROR);
      return;
    } else if (invoiceBatchInventory?.length <= 0) {
      customToast(toastMessages.PLEASE_SELECT_SOME_PRODUCT, toastType.ERROR);
      return;
    } else if (
      isAllSystemHasSerialNumber(currentStore, invoiceBatchInventory)
    ) {
      customToast(toastMessages.SERIAL_NUMBER_REQUIRED_BATCH, toastType.ERROR);
      return;
    }

    //-------prepare Invoice Inventory
    const invoiceInventory = invoiceBatchInventory;
    const dataToSend = {
      invoiceId: invoiceId,
      invoiceDate: invoiceDate,
      note: note,
      invoiceType: type,
      inventory: invoiceInventory,
      vendor: {
        id: selectedVendor?.value,
        name: selectedVendor?.label,
      },
      store: {
        id: currentStore?.id,
        name: currentStore?.storeName,
      },
    };
    if (editInvoiceData?.id) {
      dataToSend.id = editInvoiceData?.id;
    }
    switch (type) {
      case invoiceConstants.DRAFT:
        editInvoiceData?.id
          ? editInvoice(dataToSend, invoiceGridState, handleHideModal)
          : addInvoice(
              currentStore?.id,
              dataToSend,
              invoiceGridState,
              handleHideModal
            );
        break;
      case invoiceConstants.FULFILLED:
        handleFulfillInvoice(
          { data: dataToSend },
          invoiceGridState,
          handleHideModal
        );
        break;
      default:
        break;
    }
  };

  //-------handle invoice date change
  const handleInvoiceDateChange = (value) => {
    setInvoiceDate(value);
  };

  const handleAddCustomItem = () => {
    setEditCustomProduct(EMPTY_STRING);
    toggleCustomItemModal();
  };

  //-------Handle table sort
  const onTableSort = (column, sortDirection) => {
    columnHeaders(
      columnHeaders.map((col) => {
        if (col.id === column.id) {
          return {
            ...col,
            sortDirection,
          };
        } else {
          return {
            ...col,
            sortDirection: null,
          };
        }
      })
    );

    setDefaultSortFieldId(column.id);
  };

  //-------handle rows selection change
  const handleRowSelectionChange = useCallback((state) => {
    setRowsToUpdateCondition(state.selectedRows);
  }, []);

  //------ handle clear batch
  const handleClearBatch = () => {
    setInvoiceBatchInventory([]);
  };
  const scrollToTop = () => {
    var tableElement = document.getElementsByClassName("rdt_TableBody")[0];
    if (tableElement) {
      tableElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  //-------handle conformation actions
  const handleConfirmYesButtonClick = () => {
    handleClearBatch();
    toggleConfirmationModal();
  };

  const handleConfirmNoButtonClick = () => {
    toggleConfirmationModal();
  };

  //-------useEffect
  const prevLength = useRef(invoiceBatchInventory?.length);
  useEffect(() => {
    if (invoiceBatchInventory?.length > prevLength.current) {
      getInStockProducts(
        currentStore,
        inventoryActions,
        invoiceBatchInventory,
        setInvoiceBatchInventory,
        markupPresets,
        handleCalculateEachProductPercentage,
        tradeinMargin,
        shopifySettings
      );
    }
    prevLength.current = invoiceBatchInventory?.length;
  }, [invoiceBatchInventory?.length]);

  //-------update product condition and type
  useEffect(() => {
    if (
      priceChartingProductInfo &&
      isAddInvoiceModal &&
      !addInventoryItemModal
    ) {
      activateSpinner(inventoryConstants.ADD_ITEM_IN_BATCH);
      setDefaultProductDataObject(
        markupPresets,
        setRarities,
        currentStore,
        inventoryActions,
        productDataObject,
        invoiceBatchInventory,
        setSelectedRarity,
        tradeinMargin,
        true,
        setProductDataObject,
        setInvoiceBatchInventory,
        priceChartingProductInfo,
        handleCalculateEachProductPercentage,
        scrollToTop,
        emptyPriceChartingProductObject,
        customTypes,
        shopifySettings
      );
      deactivateSpinner(inventoryConstants.ADD_ITEM_IN_BATCH);
    }
  }, [priceChartingProductInfo]);

  return (
    <>
      <Modal
        size="lg"
        centered
        backdrop="static"
        animation={true}
        onHide={handleHideModal}
        dialogClassName="modal-90w"
        show={isAddInvoiceModal}
        className={`add-inventory-modal`}
      >
        <Modal.Header closeButton className="add-inventory-modal-header">
          <Modal.Title>
            <span className="add-inventory-modal-header-name">Add Invoice</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="add-inventory-modal-body py-0">
          <Row className="m-0">
            <Col md={2} className="ps-0 mb-3">
              <NewDatePicker
                IconImage={ClockIcon}
                onDateChange={(date) => handleInvoiceDateChange(date)}
                noOptionsMessage="No Date Found"
                placeholder="Date"
                label={"Date"}
                value={invoiceDate}
              />
            </Col>
            <Col md={2} className=" mb-3">
              <VendorDropdown
                isVendor={
                  editInvoiceData?.vendor
                    ? {
                        value: editInvoiceData?.vendor?.id,
                        label: editInvoiceData.vendor.name,
                      }
                    : EMPTY_STRING
                }
                getSelectedVendor={setSelectedVendor}
              />
            </Col>
            <Col md={2} className="mb-3">
              <SimpleInputTextField
                label="Invoice ID"
                value={invoiceId}
                onChange={(e) => setInvoiceId(e.target.value)}
                wrapperClassName=""
                placeHolder="Enter Invoice ID"
              />
            </Col>
            <Col md={3} className=" mb-3"></Col>
            {rowsToUpdateCondition?.length ? (
              <Col md={3} className="d-flex justify-content-end pe-md-0 gap-2">
                <Button
                  label={buttonNameConstants.DELETE}
                  IconImage={DeleteIcon}
                  type="button"
                  buttonType={buttonTypeConstants.RED_BUTTON}
                  handleClick={() => {
                    handleBatchBulkDelete(
                      toggledClearRows,
                      invoiceBatchInventory,
                      setToggleClearRows,
                      setInvoiceBatchInventory,
                      rowsToUpdateCondition,
                      setRowsToUpdateCondition
                    );
                  }}
                  isDisabled={isSpinnerEnabled(spinnerArray, [
                    inventoryConstants.ADD_INVENTORY,
                    transactionConstants.ADD_TRADE_BATCH_ITEM,
                  ])}
                />
                <Button
                  label={buttonNameConstants.BULK_UPDATE}
                  type="button"
                  handleClick={() => {
                    handleBulkUpdateCondition(
                      isBulkModal,
                      setIsBulkModal,
                      rowsToUpdateCondition
                    );
                  }}
                  isDisabled={isSpinnerEnabled(spinnerArray, [
                    inventoryConstants.ADD_INVENTORY,
                    transactionConstants.ADD_TRADE_BATCH_ITEM,
                  ])}
                />
              </Col>
            ) : invoiceBatchInventory?.length ? (
              <Col md={3} className="d-flex justify-content-end pe-md-0 gap-2">
                {!rowsToUpdateCondition?.length && (
                  <Button
                    label={buttonNameConstants.CLEAR}
                    type="button"
                    buttonType={buttonTypeConstants.LIGHT_PURPLE}
                    handleClick={() => {
                      toggleConfirmationModal();
                    }}
                    isDisabled={isSpinnerEnabled(spinnerArray, [
                      inventoryConstants.ADD_INVENTORY,
                      transactionConstants.ADD_TRADE_BATCH_ITEM,
                    ])}
                  />
                )}
              </Col>
            ) : (
              ""
            )}
            <Col md={10} className="mb-0 ps-md-0">
              <SearchInventory
                isBatch={true}
                customTypes={customTypes}
                isSearchCustomProduct={true}
                asyncSelectRef={asyncSelectRef}
                customCategories={customCategories}
                modalType={inventoryConstants.INVOICE_BATCH_MODAL}
              />
            </Col>
            <Col md={2}>
              <Button
                IconImage={AddIcon}
                isDisabled={false}
                handleClick={handleAddCustomItem}
                label={buttonNameConstants.ADD_CUSTOM_ITEM}
              />
            </Col>
            <Col md={12} className="px-0 mt-3">
              <EditableReactDataTableComponent
                selectableRows
                tableId={TABLE_IDS.ADD_INVOICE_BATCH}
                columns={columnHeaders}
                onSort={onTableSort}
                gridState={gridState}
                data={[...invoiceBatchInventory].reverse()}
                setGridState={setGridState}
                clearSelectedRows={toggledClearRows}
                total={invoiceBatchInventory?.length}
                defaultSortFieldId={defaultSortFieldId}
                handleRowSelectionChange={handleRowSelectionChange}
              />
            </Col>
            <Col md={6} className="ps-md-0 ">
              <EditOrResetCogs
                data={totalValues}
                cogsPrice={totalValues.totalCost}
                isDisabled={!invoiceBatchInventory?.length}
                handleRefresh={() =>
                  handleResetPrices(
                    markupPresets,
                    false,
                    invoiceBatchInventory,
                    setInvoiceBatchInventory,
                    tradeinMargin,
                    handleCalculateEachProductPercentage,
                    currentStore,
                    true
                  )
                }
                handleCogsChange={(data) => {
                  handleTotalCogsValueChange(
                    data,
                    setTotalCost,
                    invoiceBatchInventory,
                    setInvoiceBatchInventory
                  );
                }}
              />
              <div className="input-field-wrapper input-textarea-wrapper invoice-textarea mt-2">
                <textarea
                  value={note}
                  placeholder="Notes..."
                  onChange={(e) => setNote(e.target.value)}
                  className={`input-textfield ps-3 invoice-textarea`}
                />
              </div>
            </Col>
            <Col md={6} className="pe-md-0">
              <InventoryOverviewThreeCards
                data={[
                  {
                    label: "Total Items",
                    value: parseToThousandSeperatorWholeNumber(
                      totalValues?.totalItems || 0
                    ),
                  },
                  {
                    label: "Total Market Value",
                    value: parseToThousandSeperatorDecimalNumber(
                      totalValues?.totalMarketPrice || 0
                    ),
                  },
                  {
                    label: "Total Stock Price",
                    value: parseToThousandSeperatorDecimalNumber(
                      totalValues?.totalPrice || 0
                    ),
                  },
                ]}
              />
              <Row className="m-0 mt-3">
                <Col md={4} className="ps-md-0">
                  <Button
                    label={buttonNameConstants.CANCEL}
                    className="w-100 "
                    type="button"
                    handleClick={handleHideModal}
                    buttonType={buttonTypeConstants.GHOST_BUTTON}
                    isDisabled={false}
                  />
                </Col>
                <Col md={4}>
                  <Button
                    className="w-100"
                    isDisabled={false}
                    handleClick={() =>
                      handleInvoiceSubmit(invoiceConstants.DRAFT)
                    }
                    label={buttonNameConstants.SAVE_AS_DRAFT}
                    buttonType={buttonTypeConstants.LIGHT_PURPLE}
                  />
                </Col>
                <Col md={4} className="pe-md-0">
                  <Button
                    className="w-100"
                    isDisabled={false}
                    handleClick={() =>
                      handleInvoiceSubmit(invoiceConstants.FULFILLED)
                    }
                    label={buttonNameConstants.MARK_AS_FULFILLED}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      {addInventoryItemModal && (
        <BatchProductEdit
          addToCart={(editProduct) => {
            addToCartInBatchTrade(
              editProduct,
              invoiceBatchInventory,
              setEditTradeObject,
              setInvoiceBatchInventory
            );
          }}
          editProductObject={editTradeObject}
          isBatchProductEditModal={addInventoryItemModal}
          toggleIsBatchProductEditModal={toggleAddInventoryItemModal}
        />
      )}
      <BatchBulkUpdateModal
        isBulkModal={isBulkModal}
        setIsBulkModal={setIsBulkModal}
        toggledClearRows={toggledClearRows}
        setToggleClearRows={setToggleClearRows}
        addBatchInventory={invoiceBatchInventory}
        bulkUpdateCondition={bulkUpdateCondition}
        rowsToUpdateCondition={rowsToUpdateCondition}
        setAddBatchInventory={setInvoiceBatchInventory}
        setBulkUpdateCondition={setBulkUpdateCondition}
        setRowsToUpdateCondition={setRowsToUpdateCondition}
      />
      {isCustomItemModal && (
        <AddCustomItem
          addToCart={(editProduct) => {
            addToCartInBatchTrade(
              editProduct,
              invoiceBatchInventory,
              setEditTradeObject,
              setInvoiceBatchInventory
            );
          }}
          invoiceBatchInventory={invoiceBatchInventory}
          setInvoiceBatchInventory={setInvoiceBatchInventory}
          editCustomProduct={editCustomProduct}
          isCustomItemModal={isCustomItemModal}
          toggleCustomItemModal={toggleCustomItemModal}
        />
      )}
      <ConfirmationModal
        message={toastMessages.CLEAR_BATCH_WARNING}
        isConfirmationModal={isConfirmationModal}
        handleNoButtonClick={handleConfirmNoButtonClick}
        handleYesButtonClick={handleConfirmYesButtonClick}
        toggleConfirmationModal={toggleConfirmationModal}
      />
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  shopify: state.shopify,
  tradeDiscount: state.tradeDiscount,
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
  productTags: state.inventory.productTags,
  itemOrganization: state.itemOrganization,
  invoiceBatchInventory: state.invoice.invoiceBatchInventory,
  priceChartingProductInfo: state.inventory.priceChartingProductInfo,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  setInvoiceBatchInventory: (invoiceBatch) =>
    dispatch(invoiceActions.setInvoiceBatchInventory(invoiceBatch)),
  emptyPriceChartingProductObject: () =>
    dispatch(inventoryActions.emptyPriceChartingProductObject()),
  addInvoice: (storeId, data, gridState, handleHideModal) =>
    dispatch(
      invoiceActions.addInvoice(storeId, data, gridState, handleHideModal)
    ),
  editInvoice: (data, gridState, handleHideModal) =>
    dispatch(invoiceActions.editInvoice(data, gridState, handleHideModal)),
});

//-------Export AddInvoice Component
export default connect(mapStateToProps, mapDispatchToProps)(AddInvoice);
